/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnteResDto } from '../../models/ente-res-dto';
import { PaginatedDocumented } from '../../models/paginated-documented';

export interface EntiControllerFindManyEnti$Params {
  /**
   * Page number to retrieve. If you provide invalid value the default page number will applied
   *
   * **Example:** 1
   *
   *
   * **Default Value:** 1
   */
  page?: number;

  /**
   * Number of records per page.
   *
   *
   * **Example:** 20
   *
   *
   *
   * **Default Value:** 20
   *
   *
   *
   * **Max Value:** 0
   *
   *
   * If provided value is greater than max value, max value will be applied.
   */
  limit?: number;

  /**
   * Filter by id query param.
   *
   * **Format:** filter.id={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.id=$eq:John Doe&filter.id=$in:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $in
   *
   * - $and
   *
   * - $or
   */
  'filter.id'?: Array<string>;

  /**
   * Filter by tipo.id query param.
   *
   * **Format:** filter.tipo.id={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.tipo.id=$eq:John Doe&filter.tipo.id=$in:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $in
   *
   * - $and
   *
   * - $or
   */
  'filter.tipo.id'?: Array<string>;

  /**
   * Filter by codice query param.
   *
   * **Format:** filter.codice={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.codice=$btw:John Doe&filter.codice=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.codice'?: Array<string>;

  /**
   * Filter by codiceFiscale query param.
   *
   * **Format:** filter.codiceFiscale={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.codiceFiscale=$btw:John Doe&filter.codiceFiscale=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.codiceFiscale'?: Array<string>;

  /**
   * Filter by denominazione query param.
   *
   * **Format:** filter.denominazione={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.denominazione=$btw:John Doe&filter.denominazione=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.denominazione'?: Array<string>;

  /**
   * Filter by indirizzo query param.
   *
   * **Format:** filter.indirizzo={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.indirizzo=$btw:John Doe&filter.indirizzo=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.indirizzo'?: Array<string>;

  /**
   * Filter by luogo.codice query param.
   *
   * **Format:** filter.luogo.codice={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.luogo.codice=$btw:John Doe&filter.luogo.codice=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.luogo.codice'?: Array<string>;

  /**
   * Filter by luogo.comune query param.
   *
   * **Format:** filter.luogo.comune={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.luogo.comune=$btw:John Doe&filter.luogo.comune=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.luogo.comune'?: Array<string>;

  /**
   * Filter by luogo.codiceStato query param.
   *
   * **Format:** filter.luogo.codiceStato={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.luogo.codiceStato=$btw:John Doe&filter.luogo.codiceStato=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.luogo.codiceStato'?: Array<string>;

  /**
   * Filter by cap query param.
   *
   * **Format:** filter.cap={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.cap=$btw:John Doe&filter.cap=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.cap'?: Array<string>;

  /**
   * Filter by localita query param.
   *
   * **Format:** filter.localita={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.localita=$btw:John Doe&filter.localita=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.localita'?: Array<string>;

  /**
   * Filter by telefono query param.
   *
   * **Format:** filter.telefono={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.telefono=$btw:John Doe&filter.telefono=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.telefono'?: Array<string>;

  /**
   * Filter by eMail query param.
   *
   * **Format:** filter.eMail={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.eMail=$btw:John Doe&filter.eMail=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.eMail'?: Array<string>;

  /**
   * Filter by urlWeb query param.
   *
   * **Format:** filter.urlWeb={$not}:OPERATION:VALUE
   *
   *
   *
   * **Example:** filter.urlWeb=$btw:John Doe&filter.urlWeb=$contains:John Doe
   *
   * **Available Operations**
   * - $eq
   *
   * - $gt
   *
   * - $gte
   *
   * - $in
   *
   * - $null
   *
   * - $lt
   *
   * - $lte
   *
   * - $btw
   *
   * - $ilike
   *
   * - $sw
   *
   * - $contains
   *
   * - $not
   *
   * - $and
   *
   * - $or
   */
  'filter.urlWeb'?: Array<string>;

  /**
   * Parameter to sort by.
   * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
   *
   * **Format:** {fieldName}:{DIRECTION}
   *
   *
   * **Example:** sortBy=id:DESC&sortBy=tipo.id:DESC
   *
   *
   * **Default Value:** denominazione:ASC
   *
   * **Available Fields**
   * - id
   *
   * - tipo.id
   *
   * - codice
   *
   * - denominazione
   *
   * - codiceFiscale
   *
   * - indirizzo
   *
   * - luogo.codice
   *
   * - luogo.comune
   *
   * - luogo.codiceStato
   *
   * - cap
   *
   * - localita
   *
   * - telefono
   *
   * - eMail
   *
   * - urlWeb
   */
  sortBy?: Array<
    | 'id:ASC'
    | 'id:DESC'
    | 'tipo.id:ASC'
    | 'tipo.id:DESC'
    | 'codice:ASC'
    | 'codice:DESC'
    | 'denominazione:ASC'
    | 'denominazione:DESC'
    | 'codiceFiscale:ASC'
    | 'codiceFiscale:DESC'
    | 'indirizzo:ASC'
    | 'indirizzo:DESC'
    | 'luogo.codice:ASC'
    | 'luogo.codice:DESC'
    | 'luogo.comune:ASC'
    | 'luogo.comune:DESC'
    | 'luogo.codiceStato:ASC'
    | 'luogo.codiceStato:DESC'
    | 'cap:ASC'
    | 'cap:DESC'
    | 'localita:ASC'
    | 'localita:DESC'
    | 'telefono:ASC'
    | 'telefono:DESC'
    | 'eMail:ASC'
    | 'eMail:DESC'
    | 'urlWeb:ASC'
    | 'urlWeb:DESC'
  >;

  /**
   * Search term to filter result values
   *
   * **Example:** John
   *
   *
   * **Default Value:** No default value
   */
  search?: string;

  /**
   * List of fields to search by term to filter result values
   *
   * **Example:** id,tipo.id,codice,denominazione,codiceFiscale
   *
   *
   * **Default Value:** By default all fields mentioned below will be used to search by term
   *
   * **Available Fields**
   * - id
   *
   * - tipo.id
   *
   * - codice
   *
   * - denominazione
   *
   * - codiceFiscale
   *
   * - indirizzo
   *
   * - luogo.codice
   *
   * - luogo.comune
   *
   * - luogo.codiceStato
   *
   * - cap
   *
   * - localita
   *
   * - telefono
   *
   * - eMail
   *
   * - urlWeb
   */
  searchBy?: Array<string>;
}

export function entiControllerFindManyEnti(
  http: HttpClient,
  rootUrl: string,
  params?: EntiControllerFindManyEnti$Params,
  context?: HttpContext,
): Observable<
  StrictHttpResponse<
    PaginatedDocumented & {
      data?: Array<EnteResDto>;
      meta?: {
        select?: Array<string>;
        filter?: {
          id?: string | Array<string>;
          'tipo.id'?: string | Array<string>;
          codice?: string | Array<string>;
          codiceFiscale?: string | Array<string>;
          denominazione?: string | Array<string>;
          indirizzo?: string | Array<string>;
          'luogo.codice'?: string | Array<string>;
          'luogo.comune'?: string | Array<string>;
          'luogo.codiceStato'?: string | Array<string>;
          cap?: string | Array<string>;
          localita?: string | Array<string>;
          telefono?: string | Array<string>;
          eMail?: string | Array<string>;
          urlWeb?: string | Array<string>;
        };
      };
    }
  >
> {
  const rb = new RequestBuilder(
    rootUrl,
    entiControllerFindManyEnti.PATH,
    'get',
  );
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.id', params['filter.id'], {});
    rb.query('filter.tipo.id', params['filter.tipo.id'], {});
    rb.query('filter.codice', params['filter.codice'], {});
    rb.query('filter.codiceFiscale', params['filter.codiceFiscale'], {});
    rb.query('filter.denominazione', params['filter.denominazione'], {});
    rb.query('filter.indirizzo', params['filter.indirizzo'], {});
    rb.query('filter.luogo.codice', params['filter.luogo.codice'], {});
    rb.query('filter.luogo.comune', params['filter.luogo.comune'], {});
    rb.query(
      'filter.luogo.codiceStato',
      params['filter.luogo.codiceStato'],
      {},
    );
    rb.query('filter.cap', params['filter.cap'], {});
    rb.query('filter.localita', params['filter.localita'], {});
    rb.query('filter.telefono', params['filter.telefono'], {});
    rb.query('filter.eMail', params['filter.eMail'], {});
    rb.query('filter.urlWeb', params['filter.urlWeb'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<
          PaginatedDocumented & {
            data?: Array<EnteResDto>;
            meta?: {
              select?: Array<string>;
              filter?: {
                id?: string | Array<string>;
                'tipo.id'?: string | Array<string>;
                codice?: string | Array<string>;
                codiceFiscale?: string | Array<string>;
                denominazione?: string | Array<string>;
                indirizzo?: string | Array<string>;
                'luogo.codice'?: string | Array<string>;
                'luogo.comune'?: string | Array<string>;
                'luogo.codiceStato'?: string | Array<string>;
                cap?: string | Array<string>;
                localita?: string | Array<string>;
                telefono?: string | Array<string>;
                eMail?: string | Array<string>;
                urlWeb?: string | Array<string>;
              };
            };
          }
        >;
      }),
    );
}

entiControllerFindManyEnti.PATH = '/admin/ente';
